<script lang="ts">
    import { cn } from "../cn";
    export let value: number = 0;
    export let min = 0;
    export let max = 100;
    export let step = 1;
    export let id: string | undefined = undefined;
    export let disabled = false;
    let className = "";
    export { className as class };

    $: pct = ((value - min) / (max - min)) * 100;
</script>

<div class={cn("relative w-full h-5 flex items-center", className)}>
    <!-- Track -->
    <div
        class="absolute inset-x-0 h-1.5 rounded-full bg-[var(--input)]"
    ></div>
    <!-- Filled portion -->
    <div
        class="absolute h-1.5 rounded-full bg-[var(--primary)]"
        style="width: {pct}%"
    ></div>
    <!-- Native input on top, transparent -->
    <input
        type="range"
        {id}
        {min}
        {max}
        {step}
        {disabled}
        bind:value
        on:input
        on:change
        class="range-input absolute inset-x-0 h-5 w-full appearance-none bg-transparent cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
    />
</div>

<style>
    .range-input::-webkit-slider-thumb {
        appearance: none;
        width: 18px;
        height: 18px;
        border-radius: 50%;
        background: white;
        border: 2px solid var(--primary);
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);
        cursor: pointer;
        transition: transform 0.1s;
    }
    .range-input::-webkit-slider-thumb:hover {
        transform: scale(1.1);
    }
    .range-input::-moz-range-thumb {
        width: 18px;
        height: 18px;
        border-radius: 50%;
        background: white;
        border: 2px solid var(--primary);
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);
        cursor: pointer;
    }
    .range-input::-moz-range-track {
        background: transparent;
    }
</style>
